module.exports = __webpack_public_path__ + "static/media/phone-button@3x.221a29d5.png";